
function initWholesale(){
  bindEvents();
  recalcWholesale();
}

function bindEvents(){
  const inputs = document.querySelectorAll('input[type="number"]');
  inputs.forEach(input => {
    input.addEventListener('input', recalcWholesale);
    input.addEventListener('change', recalcWholesale);
  });

  document.querySelectorAll('.qty-plus').forEach(btn=>{
    btn.onclick = () => {
      const input = btn.parentElement.querySelector('input');
      input.value = parseInt(input.value||0)+1;
      recalcWholesale();
    };
  });

  document.querySelectorAll('.qty-minus').forEach(btn=>{
    btn.onclick = () => {
      const input = btn.parentElement.querySelector('input');
      input.value = Math.max(0, parseInt(input.value||0)-1);
      recalcWholesale();
    };
  });
}

function getPrice(){
  const priceEl = document.querySelector('[data-product-price], .price, .product__price');
  if(!priceEl) return 8.99;
  const txt = priceEl.textContent.replace(/[^0-9.]/g,'');
  return parseFloat(txt)||8.99;
}

function recalcWholesale(){
  let total = 0;

  document.querySelectorAll('input[type="number"]').forEach(i=>{
    total += parseInt(i.value)||0;
  });

  let discount = 0;
  if(total >= 48) discount = 0.10;
  else if(total >= 24) discount = 0.06;
  else if(total >= 12) discount = 0.03;

  const price = getPrice();
  const subtotal = total * price;
  const savings = subtotal * discount;
  const final = subtotal - savings;

  // ===== UI UPDATES =====

  // total units
  document.querySelectorAll('[data-total-units]').forEach(el=>{
    el.textContent = total;
  });

  // savings %
  document.querySelectorAll('.quantity-savings, [data-savings-percent]').forEach(el=>{
    el.textContent = Math.round(discount*100) + "%";
  });

  // savings $
  document.querySelectorAll('[data-savings]').forEach(el=>{
    el.textContent = savings.toFixed(2);
  });

  // total
  document.querySelectorAll('[data-total], .estimated-total').forEach(el=>{
    el.textContent = "$" + final.toFixed(2);
  });

  // bottom bar
  const bar = document.querySelector('.sticky-cart, .bottom-bar, [data-bottom-bar]');
  if(bar){
    bar.textContent = total + " shirts | $" + final.toFixed(2);
  }

  // tier highlight
  const tiers = document.querySelectorAll('.wholesale-tier, .tier');
  tiers.forEach(t=>t.classList.remove('active'));

  if(total >= 48 && tiers[3]) tiers[3].classList.add('active');
  else if(total >= 24 && tiers[2]) tiers[2].classList.add('active');
  else if(total >= 12 && tiers[1]) tiers[1].classList.add('active');
  else if(tiers[0]) tiers[0].classList.add('active');
}

document.addEventListener('DOMContentLoaded', initWholesale);
document.addEventListener('shopify:section:load', initWholesale);
